import { Notice } from "../types/notice";
import { ApiResponse } from "../types/api";
import { api } from "./api";

export const noticeService = {
  // 모든 공지사항 조회
  getAllNotices: async (): Promise<Notice[]> => {
    const response = await api.get<ApiResponse<Notice[]>>("/api/notices");
    return response.data.data;
  },

  // ID로 공지사항 조회
  getNoticeById: async (id: number): Promise<Notice> => {
    const response = await api.get<ApiResponse<Notice>>(`/api/notices/${id}`);
    return response.data.data;
  },

  // 공지사항 생성
  createNotice: async (
    data: Omit<Notice, "id" | "createdAt" | "updatedAt">,
  ): Promise<Notice> => {
    const response = await api.post<ApiResponse<Notice>>("/api/notices", data);
    return response.data.data;
  },

  // 공지사항 수정
  updateNotice: async (id: number, data: Partial<Notice>): Promise<Notice> => {
    const response = await api.put<ApiResponse<Notice>>(`/api/notices/${id}`, data);
    // 백엔드가 빈 응답을 반환하면 업데이트된 데이터를 직접 반환
    if (!response.data.data) {
      // 기존 데이터와 업데이트된 필드를 병합하여 반환
      return {
        id,
        ...data,
        updatedAt: new Date().toISOString(),
      } as Notice;
    }
    return response.data.data;
  },

  // 공지사항 삭제
  deleteNotice: async (id: number): Promise<void> => {
    await api.delete(`/api/notices/${id}`);
  },
};
